import React from "react";
import Timeline from "../components/Timeline";

const History = () => {
  return (
    <div className="pt-[200px]">
      <Timeline />
    </div>
  );
};

export default History;
